
import { useCallback, useEffect, useState } from "react"
import * as service from "../service/StpTimeSheetApi"
import { useDispatch, useSelector } from "react-redux"
import { Alert } from "antd"
import { setIsLoading } from "../slices/TimeSheetRoleSlice";
import { useNavigate } from "react-router-dom";
import useTimeSheetMasterData from "./useTimeSheetMasterData";
import { setRolePaginationList, setTimeSheetRole } from "../slices/TimeSheetMasterDataSlice";

function useStpTimeSheetCreateRole() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { currentCompany, currentEmployee } = useSelector((state) => state.company)
    const { isLoading, timeSheetRole } = useSelector((state) => state.timeSheetMasterData)

    const getStpTimeSheetRoleList = useCallback(async (params) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.getStpTimeSheetRoleList({
                ...params,
                companyId: currentCompany,
                employeeId: currentEmployee
            })
            dispatch(setRolePaginationList(response?.data?.page?.content || []))
            dispatch(setIsLoading(false))
        } catch (error) {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    const onSubmit = useCallback(async (params) => {
        try {
            dispatch(setIsLoading(true))
            const response = await service.editStpTimeSheetRole({
                ...params,
                companyId: currentCompany,
                employeeId: currentEmployee
            })
            dispatch(setIsLoading(false))
            if (response?.status?.code != 200) {
                // Alert("")
            }
            navigate("/setting_timesheet/masterdata")
            getStpTimeSheetRoleList({ page: 0, size: 10 })
        } catch (error) {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee, getStpTimeSheetRoleList])

    const onEdit = useCallback((params) => {
        navigate("/setting_timesheet/masterdata/edit_role")
        dispatch(setTimeSheetRole(params))
    }, [dispatch])

    return {
        onSubmit,
        isLoading,
        timeSheetRole,
        onEdit
    }

}
export default useStpTimeSheetCreateRole;